import React from 'react';
import { Box, Image, Typography } from '@drivekyte/web-components';
import styled from 'styled-components';
import WPTypography from '@/components/typography';

type ReviewProps = {
  title: string;
  author: string;
  date: string;
  platform: string;
  text: string;
  url?: string;
};

const Review = ({ title, author, platform, date, text, url }: ReviewProps) => (
  <Box>
    <Box
      display="flex"
      flexDirection="row"
      justifyContent="space-between"
      alignItems="center"
    >
      <Box>
        <Box marginBottom="tiny">
          <Image src="/images/icons/5stars.png" alt="Five star rating" />
        </Box>
        <Typography variant="headline-3" color="primary">
          {title}
        </Typography>
      </Box>
    </Box>
    <Box
      display="flex"
      flexDirection="row"
      alignItems="center"
      marginTop="tiny"
      marginBottom="small"
    >
      <Typography variant="label-3" color="quaternary">
        {author}
      </Typography>
      <Divider />
      <Typography variant="label-3" fontWeight={400} color="quaternary">
        {date}
      </Typography>
      <Divider />
      <Typography variant="label-3" fontWeight={400} color="quaternary">
        {url && (
          <a
            href={url}
            target="_blank"
            rel="noreferrer"
            aria-label={`link to ${platform} review by ${author}`}
          >
            {platform.toUpperCase()}
          </a>
        )}
        {!url && platform.toUpperCase()}
      </Typography>
    </Box>
    <WPTypography
      variant="p"
      color="primary"
      lineHeight={32}
      fontSize={16}
      fontWeight={400}
    >
      {`"${text}"`}
    </WPTypography>
  </Box>
);

const Divider = styled.div`
  height: 14px;
  width: 1px;
  background-color: ${({ theme }) => theme.colors.quinary};
  margin-left: ${({ theme }) => theme.spacings.xSmall}px;
  margin-right: ${({ theme }) => theme.spacings.xSmall}px;
`;

export default Review;
